<div class="bg-white">
  <div class="flex flex-col justify-center w-full">
    <div class="flex justify-center items-center border-t-2 border-gray p-2">
      <h1 class="font-bold">Scientific contribution in Ecuador</h1>
    </div>
    <div class="flex justify-center my-3">
      <div class="flex flex-wrap gap-x-3 gap-y-3 justify-center">
        <div class="lg:w-1/3 flex justify-center gap-y-3 flex-col">
          <p class="text-justify text-md">
            Ecuador, a country known for its rich biodiversity and cultural heritage, has been
            making significant strides in various research fields. Each of its provinces brings
            unique contributions, enhancing the nation's scientific and technological landscape.
          </p>
          <div
            class="border-2 border-blue-900 rounded-2 items-center justify-center"
            *ngIf="window.innerWidth >= 768"
          >
            <h3 class="bg-blue-900 text-white p-2">Most investigated topics in Ecuador</h3>
            <app-word-cloud
              class="flex justify-center"
              (eventEmitter)="emitT($event)"
              [words]="words"
            ></app-word-cloud>
          </div>

          <div
            class="border-2 border-blue-900 rounded-2 items-center justify-center"
            *ngIf="window.innerWidth < 768"
          >
            <h3 class="bg-blue-900 text-white p-2">Most investigated topics in Ecuador</h3>
            <app-word-cloud
              class="flex justify-center"
              (eventEmitter)="emitT($event)"
              [y]="200"
              [marginX]="0"
              [marginY]="0"
              [width]="window.innerWidth * 0.97"
              [words]="words"
            ></app-word-cloud>
          </div>
        </div>
        <div
          class="border-2 border-blue-900 bg-gray-100 rounded-2 w-full lg:w-fit"
          *ngIf="window.innerWidth >= 768"
        >
          <h3 class="bg-blue-900 text-white p-2">Contribution history by province</h3>
          <app-ecuador-map
            [response]="provinces"
            [width]="600"
            [height]="430"
            [scale]="3500"
            [x]="-76.7"
            [y]="-2.7"
          ></app-ecuador-map>
        </div>
        <div
          class="border-2 border-blue-900 bg-gray-100 rounded-2 w-full lg:w-fit"
          *ngIf="window.innerWidth < 768"
        >
          <h3 class="bg-blue-900 text-white p-2">Contribution history by province</h3>
          <app-ecuador-map
            [response]="provinces"
            [width]="window.innerWidth * 0.98"
            [height]="430"
            [scale]="2500"
            [x]="-73"
            [y]="-2.7"
          ></app-ecuador-map>
        </div>
      </div>
    </div>
  </div>
</div>
